import React from 'react';
import { GovTendersSearch } from '@app/common';

function PageProfileGovTenders() {
  return <GovTendersSearch />;
}

export default PageProfileGovTenders;
